import { defineEntityContract, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  CompanyDeleteRequest,
  CompanyRestoreRequest,
  CreateCompanyRequest,
  EditCompanyRequest,
} from 'shared/domain/messages/company/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { CompanyModel } from './types/model';

/**
 * Company events. A create answers with the saved model; the other outcome
 * payloads stay `unknown`: the HTTP queue sends the server's DTO after an
 * edit, `true` after a delete or restore and `{ error, messageId }` with a
 * failure. Callers only wait for them and read the companies again.
 */
export type CompanyEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allCompanies]: { hasAll?: boolean; items: CompanyModel[] };
  [DomainMessagesTypes.createdEntity]: CompanyModel;
  [DomainMessagesTypes.updatedEntity]: unknown;
  [DomainMessagesTypes.deletedEntity]: unknown;
  [DomainMessagesTypes.uploadedEntity]: unknown;
};

/** Company changes; each resolves once queued, the outcome follows as an event with its `uniqueId`. */
export type CompanyRequests = {
  create: { request: CreateCompanyRequest; response: void };
  edit: { request: EditCompanyRequest; response: void };
  remove: { request: CompanyDeleteRequest; response: void };
  restore: { request: CompanyRestoreRequest; response: void };
};

export const companyContract = defineEntityContract<CompanyModel, CompanyEvents, CompanyRequests>(
  'companyChannel',
  { collectionEvent: DomainMessagesTypes.allCompanies }
);
